export const types = {
  SET_SIDENAV_ITEMS: "SET_SIDENAV_ITEMS",
};

const initialState = {
  sideNavItems: [],
};

export default function sidenav(state = initialState, action) {
  switch (action.type) {
    case types.SET_SIDENAV_ITEMS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
